import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

interface IReadingType {
  id: number;
  label: string;
}

interface IResponse {
  data: Array<IReadingType>;
}

export const chartsReadingTypesKey = () => ['chartsReadingTypes'];
export const chartsReadingTypesFn = () => apiClient.get(`${APP_API_URL_V2}fsd/reading-types`);

const chartsReadingTypesSelect = ({ data }: AxiosResponse<IResponse>) => data.data;

export const useChartsReadingTypesQuery = () => {
  return useQuery({
    queryKey: chartsReadingTypesKey(),
    queryFn: chartsReadingTypesFn,
    select: chartsReadingTypesSelect,
  });
};
